const ACCOUNT_CONNECTOR_TYPES = [
  'account_connector_auth',
  'account_connector_confirm_user',
  'account_connector_terms',
  'salesforce_user_api_disabled',
];

const ENRICHMENT_TYPES = ['account_connector_enrichment_error'];

const DESTINATION_TYPES = [
  'destination_archived_slack_channel',
  'google_conversion_action_not_found',
];

const documentationLinks = {
  account_connector_terms:
    'https://help.clearbit.com/hc/en-us/articles/360043723133-Troubleshooting-Facebook-Ads',
  salesforce_user_api_disabled:
    'https://help.clearbit.com/hc/en-us/articles/360056896793-Troubleshooting-Salesforce-Syncs',
};

export function buildAccountNotification(
  message,
  notificationType,
  readableSourceName = 'Salesforce',
) {
  const pickType = (types) => types.some((type) => notificationType == type);
  const isEnrichmentNotification = pickType(ENRICHMENT_TYPES);
  const documentationLink = documentationLinks[notificationType];
  const messageDescription = isEnrichmentNotification
    ? `Clearbit was unable to update your fields in ${readableSourceName}.`
    : message;

  const buildHelpText = () => {
    return documentationLink ? 'Read the docs' : 'Fix this issue';
  };

  return {
    shouldRenderNotification: (isFromEnrichmentPage) => {
      return isFromEnrichmentPage
        ? isEnrichmentNotification
        : !isEnrichmentNotification;
    },
    isEnrichmentNotification,
    isAccountConnectorNotification: pickType(ACCOUNT_CONNECTOR_TYPES),
    isDestinationNotification: pickType(DESTINATION_TYPES),
    documentationLink,
    helpText: buildHelpText(),
    messageDescription,
  };
}
